import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Checkbox from 'components/shared/StandaloneCheckbox';

export default class PropertyCheckboxArray extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const isChecked = e.target.checked;
        const index = e.target.name;
        const mask = 1 << index;
        const value = isChecked ? this.props.property.value | mask : this.props.property.value &= ~mask;
        this.props.handleChange(this.props.property.info.name, value);

    }

    render() {
        const arrayLength = this.props.arrayLength;
        let isChecked = [];
        for (var i = 0; i < arrayLength; i++) {
            isChecked[i] = (this.props.property.value & (1 << i)) !== 0;
        }

        return (
            <div>
                {isChecked.map((value, index) => {
                    return (
                        <div key={index}>
                            <Row style={{}}>
                                <Col sm="5" style={{ paddingRight: '0', margin: "auto 0" }}>
                                    {index}
                                </Col>

                                <Col sm="3" style={{ paddingLeft: '0' }}>
                                    <Checkbox
                                        style={{ fontSize: '0.25rem' }}
                                        name={index.toString()}
                                        checked={value}
                                        disabled={this.props.disabled}
                                        onChange={this.handleChange} />
                                </Col>
                            </Row>
                        </div>
                    )
                }
                )
                }
            </div>
        )
    };
}
